import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../classes/User';
import { Util } from './util.service';
import { Config } from '../classes/Config';
import { map, share, tap } from 'rxjs/operators';
import { CustomEncoder } from '../classes/CustomEncoder';
import { TranslatePipe } from '../shared/translate/translate.pipe';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  public user: BehaviorSubject<User>;
  public token: string;
  public refresh_token: string;
  public rememberMe: boolean;
  public url: string;
  public userStorageKey: string = "user";
  public tokenStorageKey: string = "token";
  public sessionTimeoutStorageKey: string = "sessionTimeout";
  public refreshTokenStorageKey: string = "refreshToken";
  public rememberMeStorageKey: string = "rememberMe";
  public sessionTimeout: number;//in milliseconds
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
    })
  };

  constructor(private util: Util, private httpClient: HttpClient, private translatePipe: TranslatePipe) {
    this.user = new BehaviorSubject<User>(this.util.getFromStorage(this.userStorageKey));
    this.token = this.util.getFromStorage(this.tokenStorageKey);
    this.refresh_token = this.util.getFromStorage(this.refreshTokenStorageKey);
    this.rememberMe = this.util.getFromStorage(this.rememberMeStorageKey);
    this.sessionTimeout = this.util.getFromStorage(this.sessionTimeoutStorageKey);
    this.url = Config.BACK_END_URL + "/api/Auth/login";
  }

  public getUser(): User {
    return this.user.value;
  }

  public setUser(user: User): void {
    this.user.next(user);
    this.util.setToStorage(this.userStorageKey, user, false);
  }

  public getToken(): string {
    return this.token;
  }

  public setToken(value: string): void {
    this.token = value;
    this.util.setToStorage(this.tokenStorageKey, value, false);
  }

  public getRefreshToken(): string {
    return this.refresh_token;
  }

  public setRefreshToken(value: string): void {
    this.refresh_token = value;
    this.util.setToStorage(this.refreshTokenStorageKey, value, false);
  }


  public getSessionTimeout(): number {
    return this.sessionTimeout;
  }

  public setSessionTimeout(value: number): void {
    this.sessionTimeout = value;
    this.util.setToStorage(this.sessionTimeoutStorageKey, value, false);
  }

  public login(username: string, password: string, unifiedLogin: boolean,): Observable<string> {
    this.logout();

    return this.httpClient.post(this.url,
      JSON.stringify({ "Username": username, "Password": password, "unifiedLogin": unifiedLogin }),
      {
        headers: new HttpHeaders({
          'Content-type': 'application/json'
        }),
        responseType: 'text'
      })
      .pipe(
        tap(data => {
          this.setToken(data);

          let decodedToken: any = this.util.decodeToken(data);
          let user = JSON.parse(decodedToken.LoginInfoData);

          this.setUser(user);
          this.util.navigate("/Home");
        })
      );
  }

  refreshToken(): Observable<string> {
    let params = new HttpParams({ encoder: new CustomEncoder() })
      .append("grant_type", "refresh_token")
      .append("client_id", "")
      .append("client_secret", "")
      .append("refresh_token", this.getRefreshToken());
    return this.httpClient.post<any>(this.url, params.toString(), this.httpOptions)
      .pipe(
        share(),
        map(data => {
          let user = data.user;
          let token = data.access_token;
          this.setUser(user);
          this.setToken(token);
          this.setRefreshToken(data.refresh_token);
          return token;
        })
      );
  }

  public logout() {
    this.setUser(null);
    this.setToken(null);
    this.setSessionTimeout(null);
    this.util.clearItemFromStorage(this.userStorageKey, true, true);
    this.util.clearItemFromStorage(this.tokenStorageKey, true, true);
    this.util.clearItemFromStorage(this.refreshTokenStorageKey, true, true);
    this.util.clearItemFromStorage(this.rememberMeStorageKey, true, true);
    this.util.clearItemFromStorage(this.sessionTimeoutStorageKey, true, true);
    this.util.navigate("/login");
  }

}
